import { render, staticRenderFns } from "./InvalidLink.vue?vue&type=template&id=a6fa4b0a&"
import script from "./InvalidLink.vue?vue&type=script&lang=js&"
export * from "./InvalidLink.vue?vue&type=script&lang=js&"
import style0 from "./InvalidLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports